import { render } from "./ChangeEmailModal.vue?vue&type=template&id=0340f356"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js"

import "./ChangeEmailModal.vue?vue&type=style&index=0&id=0340f356&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__